'use client';

import { Suspense, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

/**
 * Inner component that reads search params.
 * Must be wrapped in Suspense for Next.js static prerendering.
 */
function ReferralTrackerInner() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (!ref) return;

    // Skip if already resolved for this session
    try {
      if (sessionStorage.getItem('ref_campaign') === ref) return;
    } catch { return; }

    fetch(`/api/referral/resolve?code=${encodeURIComponent(ref)}`)
      .then((res) => res.json())
      .then((data: { agent: string | null; campaign: string | null }) => {
        if (!data.agent) return;
        try {
          sessionStorage.setItem('ref_agent', data.agent);
          sessionStorage.setItem('ref_campaign', data.campaign ?? data.agent);
        } catch { /* sessionStorage unavailable */ }

        // Set dimensions immediately for any subsequent trackPageView calls
        const paq = window._paq;
        if (paq) {
          paq.push(['setCustomDimension', 1, data.agent]);
          if (data.campaign) paq.push(['setCustomDimension', 2, data.campaign]);
        }
      })
      .catch(() => { /* silent — attribution is best-effort */ });
  }, [searchParams]);

  return null;
}

export function ReferralTracker() {
  return (
    <Suspense fallback={null}>
      <ReferralTrackerInner />
    </Suspense>
  );
}
